import React, { FC } from 'react';
import { IssuuEmbedFragment } from '../types/graphqlTypes';

export const IssuuEmbed: FC<Omit<IssuuEmbedFragment, '__typename'>> = ({ issuuId }) => {
  if (!issuuId) {
    return null;
  }

  return (
    <div style={{ position: 'relative', 'padding-top': 'max(60%,326px)', height: '0', width: '100%' }}>
      <iframe
        title="issuu"
        sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox"
        allowFullScreen
        style={{
          position: 'absolute',
          border: 'none',
          width: '100%',
          height: '100%',
          left: '0',
          right: '0',
          top: '0',
          bottom: '0',
        }}
        src={issuuId}
      />
    </div>
  );
};
